<template>
  <input
    ref="input"
    type="text"
    class="general-input"
    v-model="content"
    :disabled="disabled"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: "s-input",
  props: {
    placeholder: { type: String, default: null },
    formatgreek: { default: true, type: Boolean },
    value: { default: null },

    viewMode: { type: Boolean, default: false },
    disabled: { default: false, type: Boolean }
  },
  data() {
    return {
      initialValue: null,
      content: null
    };
  },
  created() {
    this.content = this.value;
  },
  watch: {
    value(val, oldval) {
      if (val != oldval) this.content = val;
    },
    content: function(val, oldval) {
      // _log_("vhann....", val, oldval);
      // if (!val && !oldval) return;
      if (val != oldval) {
        this.$emit("input", val);
        // this.$emit("change", { val: val, oldval: oldval });
      } //{val:val,oldval:oldval})
    }
  },
  methods: {
    init() {}
    // filter(event) {
    //   _log_("k.." + event.keyCode);

    //   if (
    //     (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
    //     // event.keyCode != 46 &&
    //     event.keyCode != 44
    //   ) {
    //     event.preventDefault();
    //   }
    //   if (event.keyCode == 44) {
    //     //event.keyCode == 46 ||
    //     // _log_("k.C.F." + this.content);
    //     if (this.formatgreek && this.content.indexOf(",") > -1)
    //       event.preventDefault();
    //     // if (!this.formatgreek && this.content.indexOf(".") > -1)
    //     //   event.preventDefault();
    //   }
    // }
  }
};
</script>
<style>
.general-input {
  /* border-radius: 4px; */
  background-color: unset;
  border: none;
  /* text-align: right; */
  border-bottom: 1px solid #409eff;
}
</style>

